module.exports = __webpack_public_path__ + "media/pos-scream.efc7cc2f.mp3";